<template>
  <div :class="{'nav': true, 'fixed': fixed, 'bottomNav': bottomNav}">
    <div class="container">

      <div class="logo-box" v-if="!iframe">
        <slot name="logo-box"></slot>
      </div>

      <div class="options-box">
        <div class="separator" v-if="!iframe && separator"></div>
        <slot name="options-box"></slot>
      </div>

      <div class="play-modes-box">
        <slot name="play-modes-box"></slot>
      </div>

      <div class="authentication-box">
        <slot name="authentication-box"></slot>
      </div>

      <div class="account-box" v-if="!iframe">
        <slot name="account-box"></slot>
      </div>

    </div>
    <div class="bottomBar">

      <div class="bottom-bar-box">
        <slot name="bottom-bar-box"></slot>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    fixed: Boolean,
    bottomNav: Boolean,
    separator: {
      type: Boolean,
      default: true
    }
  },
  name: 'Nav',
  data() {
    return {
      iframe: false
    }
  },
  mounted() {
    if(window.location !== window.parent.location) {
      this.iframe = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500;600&display=swap');

.nav {
  width: 100vw;
  height: 5rem;
  background-color: #11b6a5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;

  .container {
    width: 95vw;
    height: 100%;
    display: flex;
    flex-direction: row;

    .logo-box {
      height: auto;
      width: auto;
      display: flex;
    }

    .options-box {
      flex: auto;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;

      .separator {
        width: 0.1rem;
        height: 2rem;
        background-color: #0f978a;
        border-radius: 0.2rem;
        margin-right: 1rem;
        margin-top: 0.1rem;

        @media (max-width: 400px) {
          margin-right: 0.5rem;
        }
      }
    }

    .play-modes-box {
      width: auto;
      height: 100%;
      display: flex;
    }

    .authentication-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .account-box {
      width: auto;
      height: 100%;
      display: flex;
    }
  }
}

.bottomBar {
  display: none;
  width: 95vw;
  height: 4rem;
  justify-content: center;
  align-items: center;
}

.fixed {
  position: fixed;
}

.bottomNav {
  @media (max-width: 600px) {
    height: 7.5rem;
    .bottomBar {
      display: flex;
    }
  }
}
</style>